/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateConfigResponse
 */
export interface ValidateConfigResponse {
    /**
     * 
     * @type {string}
     * @memberof ValidateConfigResponse
     */
    configString: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidateConfigResponse
     */
    errors: Array<string>;
}

export function ValidateConfigResponseFromJSON(json: any): ValidateConfigResponse {
    return ValidateConfigResponseFromJSONTyped(json, false);
}

export function ValidateConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateConfigResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'configString': json['configString'],
        'errors': json['errors'],
    };
}

export function ValidateConfigResponseToJSON(value?: ValidateConfigResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'configString': value.configString,
        'errors': value.errors,
    };
}


